@font-face {
  font-family: 'DM Sans';
  src: url('/fonts/dm-sans-400.woff2') format('woff2');
  font-weight: 400;
  font-display: swap;
}
@font-face {
  font-family: 'DM Sans';
  src: url('/fonts/dm-sans-500.woff2') format('woff2');
  font-weight: 500;
  font-display: swap;
}
@font-face {
  font-family: 'DM Sans';
  src: url('/fonts/dm-sans-600.woff2') format('woff2');
  font-weight: 600;
  font-display: swap;
}
@font-face {
  font-family: 'DM Sans';
  src: url('/fonts/dm-sans-700.woff2') format('woff2');
  font-weight: 700 900;
  font-display: swap;
}
html,
body,
#root {
  margin: 0;
  min-height: 100%;
  width: 100%;
  background: var(--renk-beyaz);
}
html.pazar-klavye-acik [data-ust-menu] {
  position: relative;
}
html.pazar-klavye-acik [data-mobil-menu],
html.pazar-klavye-acik [data-alt-menu-boslugu] {
  display: none !important;
}
[data-form-girdisi] {
  scroll-margin-block: 16px;
}
[data-mesaj-odagi='true'] {
  position: fixed !important;
  top: var(--pazar-gorunur-ust, 0px);
  left: var(--pazar-gorunur-sol, 0px);
  width: var(--pazar-gorunur-genislik, 100%);
  height: var(--pazar-gorunur-yukseklik, 100dvh);
  max-width: none !important;
  padding: 0 !important;
  margin: 0 !important;
  z-index: 110;
  background: var(--renk-beyaz);
  overflow: hidden;
}
[data-mesaj-odagi='true'] [data-mesajlar-duzeni] {
  height: 100% !important;
  min-height: 0;
}
body {
  font-family: 'DM Sans', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
* {
  box-sizing: border-box;
}
a {
  color: inherit;
  text-decoration: none;
}
button,
input,
textarea {
  font: inherit;
}
input::placeholder,
textarea::placeholder {
  opacity: 1;
}
::selection {
  background: #ffe475;
  color: #17191b;
}
:focus-visible {
  outline: 2px solid var(--renk-odak) !important;
  outline-offset: 4px !important;
  border-radius: 5px;
}
[data-sayfa-odagi]:focus {
  outline: none !important;
}
[data-uygulama] {
  min-height: 100vh;
}
[data-hero-perde] {
  background: linear-gradient(90deg, #17191b 0%, #17191bee 25%, #17191b85 45%, transparent 70%);
}
[data-ust-menu] {
  position: sticky;
  top: 0;
}
[data-ilan-izgarasi] {
  display: grid !important;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 20px !important;
}
[data-ilan-izgarasi='sik'] {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
[data-ilan-izgarasi='liste'] {
  grid-template-columns: minmax(0, 1fr) !important;
}
[data-ilan-hucresi] {
  width: auto !important;
  min-width: 0;
}
[data-ilan-karti] {
  transition:
    box-shadow 0.18s ease,
    border-color 0.18s ease;
}
[data-ust-hamburger],
[data-mobil-menu],
[data-alt-menu-boslugu] {
  display: none !important;
}
@media (max-width: 1099px), (max-width: 1439px) and (pointer: coarse) {
  [data-ust-masaustu],
  [data-ust-hesap] {
    display: none !important;
  }
  [data-ust-hamburger] {
    display: flex !important;
  }
  [data-ust-satir] {
    flex-wrap: wrap;
    gap: 9px !important;
  }
  [data-ust-satir] [data-ust-arama] {
    order: 3;
    flex: 0 0 100% !important;
    width: 100% !important;
    max-width: none !important;
  }
  [data-ust-satir] > div:last-child {
    gap: 4px !important;
  }
  [data-ust-menu][data-anasayfa='true'] [data-logo-yazisi] {
    font-size: 25px !important;
    line-height: 35px !important;
  }
  [data-ust-menu][data-anasayfa='true'] [data-arama-dugmesi] {
    display: none;
  }
  [data-mobil-menu],
  [data-alt-menu-boslugu] {
    display: flex !important;
  }
  [data-mobil-menu] {
    position: fixed !important;
    bottom: 0;
    height: calc(64px + env(safe-area-inset-bottom));
    padding-bottom: env(safe-area-inset-bottom) !important;
    padding-left: max(env(safe-area-inset-left, 0px), calc((100vw - 720px) / 2));
    padding-right: max(env(safe-area-inset-right, 0px), calc((100vw - 720px) / 2));
  }
  [data-alt-menu-boslugu] {
    height: calc(64px + env(safe-area-inset-bottom)) !important;
  }
}
@media (max-width: 1279px) {
  [data-ust-masaustu] [data-konum-metni] {
    display: none !important;
  }
}
@media (min-width: 700px) and (max-width: 1099px),
  (min-width: 700px) and (max-width: 1439px) and (pointer: coarse) {
  [data-ust-menu] > div {
    padding-inline: 28px !important;
  }
}
@media (min-width: 700px) and (max-width: 1099px),
  (min-width: 700px) and (max-width: 1439px) and (pointer: coarse) {
  [data-ust-menu] > div {
    padding-block: 10px !important;
  }
}
@media (max-width: 1099px) {
  [data-footer-govde] {
    flex-direction: column !important;
    gap: 26px !important;
  }
  [data-footer-marka] {
    width: 100% !important;
  }
  [data-footer-kolonlar] {
    flex: 0 0 auto !important;
    width: 100% !important;
    column-gap: 0 !important;
  }
}
@media (hover: hover) {
  [data-ilan-karti]:hover {
    border-color: var(--renk-gri);
    box-shadow: 0 7px 18px #17191b0a;
  }
  a:hover {
    color: inherit;
  }
}
@media (max-width: 1249px) {
  [data-ilan-izgarasi='normal'] {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media (max-width: 999px) {
  [data-ilan-izgarasi='normal'] {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 699px) {
  [data-alt-bilgi] > div {
    padding-inline: 20px !important;
  }
  [data-footer-kategoriler] {
    flex: 0 0 100% !important;
    width: 100% !important;
  }
  [data-footer-ikincil] {
    flex: 0 0 50% !important;
    width: 50% !important;
  }
  [data-footer-telif] {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 4px !important;
  }
  [data-ust-menu] > div {
    padding: 10px 20px !important;
  }
  input,
  textarea,
  select {
    font-size: 16px !important;
  }
  [data-ilan-izgarasi] {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 12px !important;
  }
  [data-vitrin-karti='true'] [data-ilan-etiketleri] {
    display: none !important;
  }
  [data-ilan-konumu] {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 2px !important;
  }
  [data-hero-perde] {
    background: linear-gradient(90deg, #17191bcc, #17191b55);
  }
  [data-ust-menu] {
    position: sticky;
    top: 0;
  }
}
@keyframes sayfa-girisi {
  from {
    opacity: 0.88;
  }
  to {
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation: none !important;
    transition: none !important;
    scroll-behavior: auto !important;
  }
}

[data-ust-menu] {
  z-index: 100;
  overflow: visible;
}
[data-ust-arama] {
  overflow: visible;
}
[data-kesif-bant-gorseli]::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, var(--renk-acik), transparent 80%);
  pointer-events: none;
}
[data-bildirim] {
  position: fixed !important;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
}
[data-bildirim] > div {
  pointer-events: auto;
}
html.pazar-klavye-acik [data-bildirim] {
  top: calc(var(--pazar-gorunur-ust, 0px) + 12px);
  bottom: auto !important;
}
[data-arama-girdisi]:focus-visible {
  outline: none !important;
}
input,
textarea {
  appearance: none;
}
input:focus,
textarea:focus,
input:focus-visible,
textarea:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
[data-form-girdisi]:focus-visible,
[data-girdi-kapsayici]:focus-within {
  border-color: var(--renk-odak) !important;
}
[data-secim-alani]:focus-visible {
  outline: none !important;
  box-shadow: none;
}
@media (max-width: 699px) {
  [data-bildirim] {
    bottom: calc(90px + env(safe-area-inset-bottom)) !important;
  }
  [data-urun-bildirimi='true'] {
    bottom: calc(150px + env(safe-area-inset-bottom)) !important;
  }
  [data-ilan-eylemleri] {
    position: fixed !important;
    bottom: calc(64px + env(safe-area-inset-bottom)) !important;
  }
}
@media (min-width: 700px) and (max-width: 1099px),
  (min-width: 700px) and (max-width: 1439px) and (pointer: coarse) {
  [data-bildirim] {
    bottom: calc(88px + env(safe-area-inset-bottom)) !important;
  }
}

@media (min-width: 700px) {
  .pazar-pencere:has([data-hamburger-menu]) {
    width: min(900px, calc(var(--pencere-genisligi, 100vw) - 48px));
  }
  [data-hamburger-menu] {
    display: grid !important;
    grid-template-columns: minmax(260px, 0.85fr) minmax(0, 1.15fr);
    grid-template-rows: auto auto auto 1fr;
    align-items: start;
    gap: 16px 24px !important;
  }
  [data-menu-hesabi],
  [data-menu-kisayollar],
  [data-menu-tercihler],
  [data-menu-cikis] {
    grid-column: 1;
    min-width: 0;
  }
  [data-menu-kisayollar] > a {
    flex-basis: 100% !important;
  }
  [data-menu-uyelik-eylemleri] {
    flex-direction: column !important;
  }
  [data-menu-katalog] {
    grid-column: 2;
    grid-row: 1 / span 4;
  }
  [data-menu-katalog] > div:first-child {
    border-top-width: 0 !important;
    padding-top: 0 !important;
  }
  [data-menu-katalog] > div:last-child {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  [data-menu-kategori] {
    min-width: 0 !important;
    flex-basis: auto !important;
  }
}
@media (min-width: 1000px) {
  [data-menu-katalog] > div:last-child {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

body {
  color: var(--renk-murekkep);
}
button,
input,
textarea,
select {
  color: inherit;
}
input::placeholder,
textarea::placeholder {
  color: var(--renk-gri);
}
[data-vurgu='kategori']:hover,
[data-vurgu='kategori']:focus-visible {
  color: var(--renk-vurguYazi);
}
[data-vurgu='kategori']:hover [data-kategori-yazisi],
[data-vurgu='kategori']:focus-visible [data-kategori-yazisi] {
  color: var(--renk-vurguYazi) !important;
}
